import { Reveal } from "@/components/Reveal";

const REASONS = [
  { n: "01", title: "Range", sub: "Wide category spread", body: "One supplier, many categories — fewer people to chase for a full order." },
  { n: "02", title: "Sincerity", sub: "We sell what we showcase", body: "A two-step verification process in billing & packing of goods to minimise human errors." },
  { n: "03", title: "Scale", sub: "Built for bulk", body: "Ordering structured for wholesale quantities, not single-piece retail." },
  { n: "04", title: "Location", sub: "Chennai-based", body: "Positioned in one of South India's core textile trading hubs." },
];

const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="relative overflow-hidden bg-crimson px-6 py-14 text-parchment sm:px-12 sm:py-28 lg:px-20 lg:py-36">
    <span aria-hidden="true" className="pointer-events-none absolute -right-8 top-0 select-none font-display text-[20vw] font-light leading-none text-parchment/[0.06]">
      Trust
    </span>
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className="flex items-center gap-4 font-accent text-[11px] font-semibold tracking-[0.35em] text-parchment">
          <span className="h-px w-12 bg-parchment" /> WHY PRAVEEN TEXTILES
        </p>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-normal leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          What buyers <span className="italic text-parchment">come back for.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-x-14 sm:grid-cols-2">
        {REASONS.map((r, i) => (
          <Reveal key={r.n} delay={(i % 2) * 0.08} data-testid={`reason-${r.n}`}>
            <div className="group border-b border-parchment/25 py-10 transition-colors duration-500 hover:border-parchment/60">
              <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1">
                <span className="font-accent text-sm font-semibold tracking-[0.2em] text-parchment transition-transform duration-500 group-hover:-translate-y-0.5">
                  {r.n}
                </span>
                <h3 className="font-display text-2xl font-normal tracking-tight sm:text-3xl">{r.title}</h3>
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-parchment/75">{r.sub}</span>
              </div>
              <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-parchment/85 sm:pl-12 sm:text-base">
                {r.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
